import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const House: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M17.86 21.28c0-.25-.2-.46-.46-.46h-2.8c-.25 0-.46.2-.46.46v5.11h3.71v-5.1Zm8.36 4.65a2.32 2.32 0 0 1-2.32 2.32H8.1a2.32 2.32 0 0 1-2.32-2.32v-10.3l-1.2 1.2a.93.93 0 0 1-1.32-1.31l11.1-11.09c.9-.9 2.37-.9 3.28 0l11.09 11.09a.93.93 0 0 1-1.32 1.31l-1.2-1.2v10.3Zm-6.5.46h4.18c.26 0 .46-.2.46-.46V13.77l-8.03-8.03a.47.47 0 0 0-.65 0l-8.03 8.03v12.16c0 .25.2.46.46.46h4.18v-5.1a2.32 2.32 0 0 1 2.32-2.33h2.79a2.32 2.32 0 0 1 2.32 2.32v5.11Z"
    />
  </Icon>
);
